import React from 'react';

const MenuIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g id='Iconography' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g fill='currentColor'>
        <path d='M23.875,21 C24.4963203,21 25,21.4477153 25,22 C25,22.5522847 24.4963203,23 23.875,23 L8.125,23 C7.50367966,23 7,22.5522847 7,22 C7,21.4477153 7.50367966,21 8.125,21 L23.875,21 Z' />
        <path d='M23.875,15 C24.4963203,15 25,15.4477153 25,16 C25,16.5522847 24.4963203,17 23.875,17 L8.125,17 C7.50367966,17 7,16.5522847 7,16 C7,15.4477153 7.50367966,15 8.125,15 L23.875,15 Z' />
        <path d='M23.875,9 C24.4963203,9 25,9.44771525 25,10 C25,10.5522847 24.4963203,11 23.875,11 L8.125,11 C7.50367966,11 7,10.5522847 7,10 C7,9.44771525 7.50367966,9 8.125,9 L23.875,9 Z' />
      </g>
    </g>
  </svg>
);

export default MenuIcon;
